import { render, staticRenderFns } from "./CustomerCustomerAccessHistory.vue?vue&type=template&id=1a13f866"
import script from "./CustomerCustomerAccessHistory.vue?vue&type=script&lang=js"
export * from "./CustomerCustomerAccessHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports